import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import i18n from 'modules/core/lib/i18n'

import { IncentivesCompensationPlanDetailRouteDocument } from 'generated/resources/graphql'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'
import { CompensationPlanDetailHeader } from 'modules/incentives/routes/resource_headers/CompensationPlanDetailHeader'

const RootPage = lazy(() => import('modules/incentives/pages/RootPage'))
const CompensationPlansList = lazy(() => import('modules/incentives/pages/CompensationPlansList'))
const CompensationPlanDetail = lazy(() => import('modules/incentives/pages/CompensationPlanDetail'))

export const incentivesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.compensations.incentives.path,
      element: <RootPage />,
      handle: {
        meta: () => ({ title: i18n.t('compensation.routes.incentives') }),
      },
      children: [
        {
          index: true,
          element: <Navigate to={navigation.compensations.incentives.plans.path} replace />,
        },
        {
          path: navigation.compensations.incentives.plans.path,
          children: [
            {
              index: true,
              element: <CompensationPlansList />,
            },
            {
              path: navigation.compensations.incentives.plans.id.path,
              element: <CompensationPlanDetail />,
              handle: {
                resource: true,
                meta: ({ watchQuery, params, session }) => {
                  const planId = params.id

                  if (!planId) {
                    return { title: '' }
                  }

                  return watchQuery({
                    query: IncentivesCompensationPlanDetailRouteDocument,
                    variables: { companyId: session.company.id, planId: planId },
                  }).map(({ data }) => {
                    const plan = data?.incentives?.compensationPlan

                    if (!plan) {
                      return { title: '' }
                    }

                    return {
                      title: plan.name,
                      headerComponent: <CompensationPlanDetailHeader plan={plan} />,
                    }
                  })
                },
              },
            },
          ],
        },
      ],
    },
  ]
}
